import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../Common/Modal ";
import useNetworkServices from "../../../Networking/baseAPIManager";
import SubHeaderMenu from "../../Sidebar/SubHeaderMenu";
import Loader from "../../Common/Loader";

const KycDetailsViewModal = () => {
  const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG;

  const [kycListData, setKycListData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [currentDocument, setCurrentDocument] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { merchantKycList, kycVerify } = useNetworkServices();

  const id = location.state._id;
  const brandName = kycListData?.businessDetils?.shopName
    ? kycListData?.businessDetils?.shopName
    : "";
  let Address = `${
    kycListData?.businessDetils?.businessCity
      ? kycListData?.businessDetils?.businessCity
      : ""
  } ${
    kycListData?.businessDetils?.businessState
      ? kycListData?.businessDetils?.businessState
      : ""
  }`;

  let locations =
    kycListData?.businessDetils?.businessCity ||
    kycListData?.businessDetils?.businessState
      ? Address
      : "N/A";

  useEffect(() => {
    let params = {
      merchantId: id,
    };
    if (id) {
      setLoading(true);
      const kycListDetail = async () => {
        try {
          const response = await merchantKycList(params);
          console.log(response?.data?.data, "response");
          if (response.status === 200) {
            setKycListData(response?.data?.data);
          }
        } catch (error) {
          console.error(error, "error");
        } finally {
          setLoading(false);
        }
      };
      kycListDetail();
    }
  }, [id]);

  const openDocument = (type) => {
    setCurrentDocument(type);
    setIsOpen(true);
  };

  const kycStatus = async (data) => {
    let kycData = {
      merchantId: id,
      kyc: data,
    };
    setDisabled(true);
    try {
      const response = await kycVerify(kycData);
      setDisabled(false);
      navigate("/kyc_verification");
    } catch (error) {
      setDisabled(false);
      console.log(error, "error");
    }
  };
  return (
    <>
      <div id="main" className="p-4">
        <h1 className="font-bold text-2xl text-slate-900 pb-5">
          <span>Merchant Management</span> /
          <span className="text-red-500">
            <SubHeaderMenu location={location} title="KYC Verification" />
          </span>
        </h1>
        <div className="flex items-center gap-4 pb-4 mb-4">
          <img
            src={`${BASE_URL_IMG}/${kycListData?.profileImage}`}
            alt="Profile"
            className="w-24 h-24 rounded-full"
          />
          <div>
            <h3 className="text-lg font-semibold text-gray-700">{`${
              kycListData.firstName || "N/A"
            } ${kycListData.lastName || " "}`}</h3>
            <p className="text-gray-500">{brandName}</p>
            <p className="text-gray-500">{locations}</p>
          </div>
        </div>

        {/* Personal Info Section */}
        <div className="mb-6">
          <div className=" flex items-center">
            <p className=" w-32 text-lg font-semibold text-red-500 mb-2">
              Personal Info
            </p>
            <hr className="w-full" />
          </div>
          <div className="grid grid-cols-2 gap-4 text-gray-600">
            <div>
              <strong>First Name: </strong>{" "}
              <span>
                {kycListData?.firstName ? kycListData?.firstName : "N/A"}
              </span>
            </div>
            <div>
              <strong>Last Name: </strong>{" "}
              <span>
                {kycListData?.lastName ? kycListData?.lastName : "N/A"}
              </span>
            </div>
            <div>
              <strong>Email Address: </strong>
              <span>{kycListData?.email ? kycListData?.email : "N/A"}</span>
            </div>
            <div>
              <strong>Phone Number: </strong>{" "}
              <span>{kycListData?.mobile ? kycListData?.mobile : "N/A"}</span>
            </div>
            <div>
              <strong>Address:</strong>{" "}
              <span>{kycListData?.address ? kycListData?.address : "N/A"}</span>
            </div>
            <div>
              <strong>Pin Code:</strong>{" "}
              <span>{kycListData?.pinCode ? kycListData?.pinCode : "N/A"}</span>
            </div>
            <div>
              <strong>City:</strong>{" "}
              <span>{kycListData?.city ? kycListData?.city : "N/A"}</span>
            </div>
            <div>
              <strong>State:</strong>{" "}
              <span>{kycListData?.state ? kycListData?.state : "N/A"}</span>
            </div>
          </div>
        </div>

        {/* Business Info Section */}
        <div className="mb-6">
          <div className=" flex items-center">
            <p className=" w-32 text-lg font-semibold text-red-500 mb-2">
              My Business
            </p>
            <hr className="w-full" />
          </div>
          <div className="grid grid-cols-2 gap-4 text-gray-600">
            <div>
              <strong>Shop Name:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.shopName
                  ? kycListData?.businessDetils?.shopName
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>Type Category:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.category?.title
                  ? kycListData?.businessDetils?.category?.title
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>Brand Name:</strong>{" "}
              <span>
                {" "}
                {kycListData?.businessDetils?.brandName
                  ? kycListData?.businessDetils?.brandName
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>GST Number:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.gstNumber
                  ? kycListData?.businessDetils?.gstNumber
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>View Shop Hour:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.workingHours
                  ? kycListData?.businessDetils?.workingHours
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>Email Address:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.business_email
                  ? kycListData?.businessDetils?.business_email
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>Phone Number:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.business_mobileNo
                  ? kycListData?.businessDetils?.business_mobileNo
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>Pin Code:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.businessPinCode
                  ? kycListData?.businessDetils?.businessPinCode
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>City:</strong>{" "}
              <sapn>
                {kycListData?.businessDetils?.businessCity
                  ? kycListData?.businessDetils?.businessCity
                  : "N/A"}
              </sapn>
            </div>
            <div>
              <strong>State:</strong>{" "}
              <span>
                {kycListData?.businessDetils?.businessState
                  ? kycListData?.businessDetils?.businessState
                  : "N/A"}
              </span>
            </div>
          </div>
        </div>

        {/* Bank Details Section */}
        <div className="mb-6 ">
          <div className=" flex items-center">
            <p className=" w-32 text-lg font-semibold text-red-500 mb-2">
              Bank Details
            </p>
            <hr className="w-full" />
          </div>
          <div className="grid grid-cols-2 gap-4 text-gray-600">
            <div>
              <strong>Bank Name:</strong>{" "}
              <span>
                {kycListData.bankDetails?.bankName
                  ? kycListData.bankDetails?.bankName
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>Account Holder Name:</strong>{" "}
              <span>
                {kycListData.bankDetails?.accountHolderName
                  ? kycListData.bankDetails?.accountHolderName
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>Account Number:</strong>
              <span className="line-through">
                {" "}
                {kycListData.bankDetails?.accountNumber
                  ? kycListData.bankDetails?.accountNumber
                  : "N/A"}
              </span>
            </div>
            <div>
              <strong>IFSC Code:</strong>{" "}
              <span>
                {kycListData.bankDetails?.ifscCode
                  ? kycListData.bankDetails?.ifscCode
                  : "N/A"}
              </span>
            </div>
          </div>
        </div>

        {/* Document Section */}
        <div className="mb-6 ">
          <div className="flex items-center">
            <p className="w-32 text-lg font-semibold text-red-500 mb-2">
              Document
            </p>
            <hr className="w-full" />
          </div>
          <div className="grid grid-cols-2 gap-4 text-gray-600">
            <div className="flex items-center justify-between">
              <strong>Aadhar Card</strong>
              <button
                className="p-2 bg-gray-100 rounded-full"
                onClick={() => openDocument("Aadhar")}
              >
                👁️
              </button>
            </div>
            <div className="flex items-center justify-between">
              <strong>Pan Card</strong>
              <button
                className="p-2 bg-gray-100 rounded-full "
                onClick={() => openDocument("Pan")}
              >
                👁️
              </button>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-4">
          <button
            className="bg-[#025D89] text-white px-4 py-2 rounded-md"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
          <button
            disabled={disabled}
            className={`bg-red-500 text-white px-4 py-2 rounded-md ${
              disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => kycStatus("Reject")}
          >
            Reject
          </button>

          <button
            disabled={disabled}
            className={`bg-green-500 text-white px-4 py-2 rounded-md ${
              disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => kycStatus("Approved")}
          >
            Approve
          </button>
        </div>
      </div>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="View Document"
        childrenClass="w-full h-auto flex justify-center p-5"
        Classes="w-10/11 md:w-2/6 h-3/6"
      >
        {currentDocument === "Aadhar" && (
          <img
            src={`${BASE_URL_IMG}/${kycListData.aadhar}`}
            alt="Aadhar Card"
            className="w-72 h-auto"
          />
        )}
        {currentDocument === "Pan" && (
          <img
            src={`${BASE_URL_IMG}/${kycListData.panCard}`}
            alt="Pan Card"
            className="w-72 h-auto"
          />
        )}
      </Modal>
      {loading && <Loader />}
    </>
  );
};

export default KycDetailsViewModal;
